const ns = "ORDERS_BULK_EDIT_LINE_ITEMS";
export const RECEIVE = `${ns}_RECEIVE`;
